'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Task = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.task = task;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _proc = require('./proc');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * A helper function to create a stateless React component that renders a Task
 * component with the given generator function.
 */


function task(generatorFunction) {
  var component = function component(props) {
    return _react2["default"].createElement(Task, _extends({
      proc: generatorFunction
    }, props));
  }; // If the function is named, use its name as the component's displayName for
  // debugging purposes.


  component.displayName = generatorFunction.name || generatorFunction.displayName;
  return component;
}
/**
 * <Task proc={...} ... />
 *
 * A Task component starts a Proc (which is basically a background process that
 * runs a generator function) when it gets mounted, and stops the Proc when it
 * gets unmounted (or when the value of the proc prop gets changed).
 *
 * The generator function will get passed a `getProps` function, which returns a
 * promise that resolves with the component's current props. If you pass a
 * function to the getProps function, the props will be passed to that function
 * and the promise returned by getProps will only resolve once that function
 * returns a truthy value.
 *
 * NOTE: A Task will only stop its Proc when it gets unmounted or the proc prop
 * is changed. To restart a Task with new props, pass a unique "key" prop, which
 * will force React to unmount the Task when the key changes.
 *
 * Alternatively, you can use the this.getProps() method (which is also passed
 * as the second argument to he generator function) to get the current state of
 * the Task's props in the middle of the Task's execution.
 */


var Task = exports.Task = function (_React$Component) {
  _inherits(Task, _React$Component);

  function Task() {
    _classCallCheck(this, Task); // Private variables.


    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Task).call(this));

    _this.onPropsReceived = null;
    _this.proc = null;
    _this.boundGetProps = _this.getProps.bind(_this);
    _this.boundOnStep = _this.onStep.bind(_this);
    _this.wasUnmounted = false;
    return _this;
  }
  /**
   * Returns a promise that resolves with the props when they match the given
   * filter, or resolves with the current props immediately if no filter
   * function is provided.
   */


  _createClass(Task, [{
    key: 'getProps',
    value: function getProps() {
      var _this2 = this;

      var filterFn = arguments.length <= 0 || arguments[0] === undefined ? function () {
        return true;
      } : arguments[0];
      return new Promise(function (resolve, reject) {
        // Check and resolve immediately if the props already match the filter.
        if (filterFn(_this2.props)) {
          resolve(_this2.props);
          return;
        }

        if (_this2.onPropsReceived !== null) {
          throw new Error('Cannot call getProps more than once at a time.');
        } // Check if the props match the filter whenever they change.


        _this2.onPropsReceived = function (nextProps) {
          if (filterFn(nextProps)) {
            resolve(nextProps);
            _this2.onPropsReceived = null;
          }
        };
      });
    }
    /**
     * Updates the state with the result of the last call for debugging purposes.
     */

  }, {
    key: 'onStep',
    value: function onStep(step) {
      // Don't update the state if the component has already been unmounted.
      if (!this.wasUnmounted) {
        this.setState({
          currentStep: step
        });
      }
    }
  }, {
    key: 'start',
    value: function start() {
      var generator = this.props.proc(this.boundGetProps);
      this.proc = (0, _proc.runProc)(generator, this.boundOnStep);
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (this.proc) {
        this.proc.cancel();
      }
    } // React lifecycle methods
    // -----------------------
    //
    // Starts a proc (which is basically a background process that runs a
    // generator function) when the Task component gets mounted, and stop the proc
    // when it gets unmounted.
    //

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.start(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.proc !== nextProps.proc) {
        console.warn('Changing the proc property of the Task component will not ' + 'cause the process to restart. Use the task() helper function instead of ' + 'using the Task component directly, or set a key prop on the Task ' + 'component to make it mount a new component when the proc changes.');
      } else {
        if (this.onPropsReceived !== null) {
          this.onPropsReceived(nextProps);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
      this.wasUnmounted = true;
    } // Task components never render anything by default.

  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Task;
}(_react2["default"].Component);

Task.propTypes = {
  proc: _react2["default"].PropTypes.func.isRequired,
  children: function children(props, propName, componentName) {
    if (props.children) {
      return new Error('Task components should not have any children. To organize ' + 'tasks in a hierarchy, use normal elements like <div>, <span>, etc.');
    }
  }
};